import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "normalize.css/normalize.css";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "assets/global.scss";
import "assets/resetCss.css";
import { BrowserRouter } from "react-router-dom";
ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
